import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { DialogProveedorComponent } from './dialog-proveedor/dialog-proveedor.component';
import { formatDate } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { DialogAddItemOcComponent } from './dialog-add-item-oc/dialog-add-item-oc.component';
import { CognitoService } from 'src/app/services/cognito.service';

import Swal from 'sweetalert2';
import { FileService } from 'src/app/services/api/file.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-add-orden-compra',
  templateUrl: './add-orden-compra.component.html',
  styleUrls: ['./add-orden-compra.component.css']
})
export class AddOrdenCompraComponent implements OnInit {
  formOC!: FormGroup;
  estadoItems = false;
  displayedColumns: string[] = [
    'item',
    'descripcion',
    'cantidad',
    'precioUnidad',
    'inafecto',
    'igv',
    'monto',
    'delete'
  ];

  lstMoneda = ["D","S"]
  lstCC = [
    {"cc":"10","descripcion":"B2B Ventas de Agencias"},
    {"cc":"11","descripcion":"B2C Ventas Web y Directos"},
    {"cc":"12","descripcion":"Ventas Huaraz"},
    {"cc":"17","descripcion":"Ingresos Administrativos"},
    {"cc":"20","descripcion":"B2B Costos directos de operación de files Agencias"},
    {"cc":"21","descripcion":"B2C Costos directos de operación de files Ventas Web y Directos"},
    {"cc":"22","descripcion":"Costos directos de operación de files Ventas Huaraz"},
  ]
  lstIgv = [18, 10];
  lstInafecto = ['I', 'N'];
  lstArea = ["VENTAS","OPERACIONES","MARQUETING"]
  DataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  tableContent: any = null;
  estado = false;

  tempSubtotal = 0;
  tempIgv = 0;
  tempTotal = 0;

  tempCondicionPago:any ={};
  currentDate = new Date().toISOString();
  usuario = '';

  resultTemp:any = {};

  constructor(public dialog: MatDialog,private fileService: FileService, private fb: FormBuilder,private changeDetectorRefs: ChangeDetectorRef,
    private router: Router, public loadingService: LoadingService, private cognitoService: CognitoService) {
      this.formOC  = this.fb.group({
        codigoOC: new FormControl(''),
        fecha: new FormControl(formatDate(new Date(), 'dd/MM/yyyy', 'en')),
        //provider: new FormControl(''),
        nombreProvider: new FormControl({value: '', disabled: true}, Validators.required),
        ruc: new FormControl({value: '', disabled: true}, Validators.required),
        direccion: new FormControl({value: '', disabled: true}, Validators.required),
        tipoProveedor: new FormControl(),
        area: new FormControl('', Validators.required),
        centroCosto: new FormControl('', Validators.required),
        moneda: new FormControl('', Validators.required),
        /* inafecto: new FormControl(''),
        igvValue: new FormControl(''), */
        observacion: new FormControl(''),
        subTotal: new FormControl(''),
        igv: new FormControl(''),
        total: new FormControl('')
      });
     }

  ngOnInit(): void {
    this.cognitoService.getUser().then((value) => this.usuario = value.username);
  }

  openDialogProvider() {
    let dialogConfig = new MatDialogConfig();

    dialogConfig.width = "80%";

    let dialogRef = this.dialog.open(DialogProveedorComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log('resultado',result);
      if(result){
        this.resultTemp = result;
        this.tempCondicionPago = result.condicionesPagos;
        this.formOC.controls['nombreProvider'].setValue(result.nombre);
        this.formOC.controls['ruc'].setValue(result.numRUC);
        this.formOC.controls['direccion'].setValue(result.direccionLegal ? result.direccionLegal : "NO FIGURA");
        this.formOC.controls['tipoProveedor'].setValue(result.tipoProveedor);
      }

    });
  }

  openDialogItem(){
    let dialogConfig = new MatDialogConfig();

    dialogConfig.width = "80%";

    dialogConfig.data = {
      item: this.tableContent ? this.tableContent.length + 1 : 1
    };

    let dialogRef = this.dialog.open(DialogAddItemOcComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      result.monto = result.cantidad*result.precioUnidad;
      result.cantidad = Number(result.cantidad);
      result.precioUnidad = Number(result.precioUnidad);
      console.log('item',result);

      if(this.tableContent ==  null){
        this.tableContent = [];
        this.tableContent.push(result);
      }else {
        this.tableContent = result ? this.tableContent.concat(result) : this.tableContent;
      }
      if(this.tableContent){
        console.log('tabla', this.tableContent);
        this.DataSource.data = this.tableContent;
        this.DataSource.paginator=this.paginator
        this.changeDetectorRefs.detectChanges();
        this.estado = true
      }
    //calcular resultado
    const temp = this.formOC.value;
          this.tempSubtotal = 0;
          this.tempIgv = 0;
          this.tempTotal = 0;
    /*   if(temp.inafecto === "I"){
        //sin igv
        this.tableContent.forEach((x: any) => {
            this.tempSubtotal = this.tempSubtotal + Number(x.monto)
         });
         this.formOC.controls['subTotal'].setValue(this.tempSubtotal);
         this.formOC.controls['igv'].setValue(0);
         this.formOC.controls['total'].setValue(this.tempSubtotal);
      }else{
        //con igv
        const igvT = temp.igvValue;
        this.tableContent.forEach((x: any) => {
          this.tempSubtotal = this.tempSubtotal + Number(x.monto);
          this.tempIgv = this.tempIgv + Number(x.monto)*igvT/100;
          this.tempTotal = this.tempSubtotal + this.tempIgv;
          console.log(this.tempSubtotal);
       });
       this.formOC.controls['subTotal'].setValue(this.tempSubtotal);
       this.formOC.controls['igv'].setValue(this.tempIgv);
       this.formOC.controls['total'].setValue(this.tempTotal);
      } */
      //calcular resultado last update
      this.tableContent.forEach((x: any) => {
        this.tempSubtotal = this.tempSubtotal + Number(x.monto);
        this.tempIgv = this.tempIgv + Number(x.monto)*(x.igv)/100;
        this.tempTotal = this.tempSubtotal + this.tempIgv;
        console.log(this.tempIgv);
     });
         this.formOC.controls['subTotal'].setValue(this.tempSubtotal);
         this.formOC.controls['igv'].setValue(this.tempIgv);
         this.formOC.controls['total'].setValue(this.tempSubtotal + this.tempIgv);
     this.estadoItems = true;
    });

  }

  removeItem(index: number) {
    this.tableContent.splice(index, 1);
    this.DataSource.data = this.tableContent;
    if(this.tableContent.length>0){
      const temp = this.formOC.value;
          this.tempSubtotal = 0;
          this.tempIgv = 0;
          this.tempTotal = 0;
      //calcular resultado last update
      this.tableContent.forEach((x: any) => {
        this.tempSubtotal = this.tempSubtotal + Number(x.monto);
        this.tempIgv = this.tempIgv + Number(x.monto)*(x.igv)/100;
        this.tempTotal = this.tempSubtotal + this.tempIgv;
        console.log(this.tempIgv);
     });
         this.formOC.controls['subTotal'].setValue(this.tempSubtotal);
         this.formOC.controls['igv'].setValue(this.tempIgv);
         this.formOC.controls['total'].setValue(this.tempSubtotal + this.tempIgv);
     this.estadoItems = true;
    }else{
      this.formOC.controls['subTotal'].setValue(0);
      this.formOC.controls['igv'].setValue(0);
      this.formOC.controls['total'].setValue(0);
      this.estadoItems = false;
    }
  }

  addDays (str: string, days: number) {
    var myDate = new Date(str);
    myDate.setDate(myDate.getDate() + days);
    return myDate.toISOString();
  }

  createOC(){
    if(this.tableContent && this.tableContent.length>0 && this.formOC.valid){
      console.log('form : ',this.formOC.value)
      const temp = this.formOC.value;
      let data: any = {};
      data.codigoOC = '';
      data.fecha = new Date().toISOString();
      data.nameProvider = this.resultTemp.nombre;
      data.rucProvider = this.resultTemp.numRUC;
      data.direccionProvider = this.resultTemp.direccionLegal;
      data.tipoProvider = this.resultTemp.tipoProveedor;
      data.area = temp.area;
      data.cc = temp.centroCosto.cc;
      data.descripcionCC = temp.centroCosto.descripcion
      data.moneda = temp.moneda;
      /* data.igvValue = temp.igvValue;
      data.inafecto = temp.inafecto; */
      data.subTotal = temp.subTotal;
      data.igv = temp.igv;
      data.total = temp.total;
      data.tipoPago = this.tempCondicionPago.condicionPago;
      data.diasPago = this.tempCondicionPago.plazoDiasFit;
     // const fechaT =  this.currentDate.setDate( this.currentDate.getDate() + (this.tempCondicionPago.plazoDiasFit ? this.tempCondicionPago.plazoDiasFit : 30) )
      data.fechaPago = this.addDays(this.currentDate,this.tempCondicionPago.plazoDiasFit ? this.tempCondicionPago.plazoDiasFit : 30);
      data.observacion = temp.observacion;
      data.aprobado = false;
      data.usuario = this.usuario;
      data.items = this.tableContent;
      console.log('data : ',data)
      this.fileService.createOrdenCompra(data).subscribe(resp => {
          console.log('resp', resp);
          if(resp.createOrdenCompra){
            Swal.fire({
              title: "Exito",
              text: "Ir a la lista de OC",
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Si"
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(["/orden-compra/listar-orden-compra"]);
              }
            });
            this.formOC.reset();
            this.tableContent = [];
            this.DataSource.data = this.tableContent;
          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Error al agregar OC',
              showConfirmButton: false,
              timer: 1500
            });
          }
      });
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'La OC no tienen items y/o faltan datos requeridos',
        showConfirmButton: false,
        timer: 1500
      });
    }



  }

}
